<template>
  <div class="cookie p-4" v-if="!cookiesAccepted">
    <div class="d-inline-flex align-items-center py-4">
      <Icon name="cookie" font-scale="2" class="mr-3" />
      <h4>{{ $t("uses_cookies") }}</h4>
    </div>
    <p class="py-2 mb-3">
      {{ $t("cookie_content") }}
    </p>

    <div class="buttons buttons--large">
      <b-button
        size="lg"
        variant="primary"
        @click="cookiesAgreed()"
        class="px-4"
      >
        {{ $t("cookie_agree") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon/Icon";
import Cookies from "js-cookie";
export default {
  name: "Cookie",
  components: { Icon },
  data() {
    return {
      cookiesAccepted: false,
    };
  },
  methods: {
    cookiesAgreed() {
      this.cookiesAccepted = true;
      Cookies.set("Cookies", "Accepted=1", { expires: 720 });
    },
  },
};
</script>

<style scoped></style>
